import React, { Component } from "react";

import {
    QuizObjectCardTable,
    QuizObjectCard
} from "../../../../store/modquiz/quiz_objects/quiz-object";

import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "./Card";
import { observer } from "mobx-react";
import "./Style.css";

interface MyProps {
    card_table: QuizObjectCardTable;
    focusField: Function;
    blurField: Function;
}

const QuizObjectCardTableHeaderComponent = () => {
    return (
        <thead>
            <tr>
                <th style={{ width: "1px", whiteSpace: "nowrap" }}>Link</th>
                <th>Title</th>
                <th>Definition</th>
            </tr>
        </thead>
    );
};

interface QuizObjectCardTableBodyComponentProps {
    card_table: QuizObjectCardTable;
}

const QuizObjectCardTableBodyComponent = observer(
    ({ card_table }: QuizObjectCardTableBodyComponentProps) => {
        return (
            <tbody>
                {card_table.getRows().map((card: QuizObjectCard, i: number) => {
                    return <Card card={card} key={i} i={i} />;
                })}
            </tbody>
        );
    }
);

class QuizObjectCardTableComponent extends Component<MyProps, any> {
    card_table: any;
    nameRef: any;

    constructor(props: any) {
        super(props);

        this.nameRef = React.createRef();

        this.addTableRow = this.addTableRow.bind(this);
        this.removeTable = this.removeTable.bind(this);
        this.restoreTable = this.restoreTable.bind(this);
        this.changeName = this.changeName.bind(this);
    }

    componentDidMount() {
        if (
            this.props.card_table.name == "" ||
            this.props.card_table.name == undefined
        ) {
            this.nameRef.focus();
        }
    }

    addTableRow() {
        this.props.card_table.addRow();
    }

    removeTable() {
        this.props.card_table.remove();
    }

    restoreTable() {
        this.props.card_table.restore();
    }

    changeName(ev: any) {
        this.props.card_table.setName(ev.currentTarget.value);
    }

    render() {
        return (
            <div>
                <FormGroup>
                    <TextField
                        id={this.props.card_table._id}
                        onChange={this.changeName}
                        value={this.props.card_table.name}
                        className="form-control"
                        inputRef={input => {
                            this.nameRef = input;
                        }}
                        label="Card Table Name"
                    />
                </FormGroup>
                <br />
                <table className="editable-table table with-links">
                    <QuizObjectCardTableHeaderComponent />
                    <QuizObjectCardTableBodyComponent
                        card_table={this.props.card_table}
                    />
                </table>
                <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                >
                    <Button onClick={this.addTableRow} color="primary">
                        + Row
                    </Button>
                    {/* <Button onClick={this.addTableColumn} color="primary">
                        + Column
                    </Button> */}
                    {this.props.card_table.deleted ? (
                        <Button color="secondary" onClick={this.restoreTable}>
                            Restore Table
                        </Button>
                    ) : (
                        <Button color="secondary" onClick={this.removeTable}>
                            Delete
                        </Button>
                    )}
                    <Box
                        component="span"
                        color={
                            this.props.card_table.status == "error"
                                ? "secondary"
                                : "primary"
                        }
                    >
                        {this.props.card_table.status}
                    </Box>
                </div>
                <span className="pull-right text-warning">
                    {this.props.card_table.cardTableReady
                        ? ""
                        : "Fill out title of card table and first card to save"}
                </span>
            </div>
        );
    }
}

export { QuizObjectCardTableComponent };
